export const siteInfo = {
  name: '天美麻花星空影视',
  slogan: '高清影视，尽在星空',
  description: '天美麻花星空影视致力于为用户提供最新、最全的高清影视资源。涵盖电影、电视剧、综艺、动漫等多种类型，随时随地畅享精彩视听体验。',
  email: 'contact@tianmeimahua.com',
  phone: '400-888-6666',
  address: '北京市朝阳区星空大厦18层',
  icp: '京ICP备2024XXXXXX号',
  social: {
    weibo: '天美麻花星空影视',
    wechat: 'tianmeimahua',
  },
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '电影', href: '/category/movie' },
  { label: '电视剧', href: '/category/tv' },
  { label: '综艺', href: '/category/variety' },
  { label: '动漫', href: '/category/anime' },
];

export const categories = [
  { slug: 'movie', name: '电影', icon: 'ri-movie-2-line', description: '院线大片、经典佳作、热门新片' },
  { slug: 'tv', name: '电视剧', icon: 'ri-tv-2-line', description: '国产剧、韩剧、美剧、日剧' },
  { slug: 'variety', name: '综艺', icon: 'ri-live-line', description: '热门综艺、真人秀、脱口秀' },
  { slug: 'anime', name: '动漫', icon: 'ri-anchor-line', description: '国产动漫、日漫、欧美动画' },
];

export const featuredMovies = [
  {
    id: '1',
    title: '流浪地球3',
    category: 'movie',
    rating: 9.2,
    year: 2026,
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20massive%20planetary%20engines%20against%20starry%20cosmos%2C%20dramatic%20orange%20and%20blue%20contrast%20lighting%2C%20cinematic%20composition%2C%20grand%20scale%20space%20exploration%20theme%2C%20Chinese%20aesthetic%20elements&width=600&height=800&seq=featured-movie-01&orientation=portrait',
    description: '太阳急速老化，持续膨胀。面对绝境，人类将开启"流浪地球计划"，试图带着地球一起逃离太阳系。',
    tags: ['科幻', '灾难', '冒险'],
    updateTime: '2026-08-01',
  },
  {
    id: '2',
    title: '长安十二时辰',
    category: 'tv',
    rating: 8.8,
    year: 2025,
    imageUrl: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%20featuring%20ancient%20Tang%20Dynasty%20capital%20city%20with%20lanterns%20and%20traditional%20architecture%20at%20night%2C%20warm%20golden%20atmospheric%20lighting%2C%20elegant%20artistic%20composition%2C%20rich%20cultural%20details&width=600&height=800&seq=featured-movie-02&orientation=portrait',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与李必携手在十二时辰内拯救长安。',
    tags: ['古装', '悬疑', '历史'],
    updateTime: '2026-07-28',
  },
  {
    id: '3',
    title: '极限挑战第十季',
    category: 'variety',
    rating: 8.5,
    year: 2026,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20variety%20show%20poster%20with%20diverse%20cast%20of%20performers%20in%20urban%20outdoor%20setting%2C%20bright%20colorful%20energetic%20atmosphere%2C%20fun%20competitive%20game%20show%20theme%2C%20modern%20cityscape%20background%20with%20warm%20summer%20lighting&width=600&height=800&seq=featured-movie-03&orientation=portrait',
    description: '中国顶级真人秀节目，明星嘉宾们通过各种极限挑战任务，展现真实、有趣的一面。',
    tags: ['真人秀', '竞技', '搞笑'],
    updateTime: '2026-08-02',
  },
  {
    id: '4',
    title: '深海',
    category: 'anime',
    rating: 9.0,
    year: 2025,
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animated%20film%20poster%20with%20magical%20underwater%20fantasy%20world%2C%20vibrant%20colorful%20coral%20reefs%20and%20glowing%20sea%20creatures%2C%20dreamy%20ethereal%20lighting%20with%20particles%2C%20artistic%20watercolor%20style%2C%20mysterious%20deep%20ocean%20atmosphere&width=600&height=800&seq=featured-movie-04&orientation=portrait',
    description: '一个现代少女误入梦幻的深海世界，邂逅了一段独特的生命旅程，探索关于勇气与成长的奥秘。',
    tags: ['奇幻', '冒险', '动画'],
    updateTime: '2026-07-25',
  },
  {
    id: '5',
    title: '孤注一掷2',
    category: 'movie',
    rating: 8.7,
    year: 2026,
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20crime%20thriller%20movie%20poster%20with%20suspenseful%20atmosphere%2C%20dark%20urban%20environment%20with%20neon%20lights%2C%20dramatic%20shadow%20composition%2C%20gripping%20tension%20between%20characters%2C%20cinematic%20noir%20aesthetic%20with%20warm%20amber%20tones&width=600&height=800&seq=featured-movie-05&orientation=portrait',
    description: '讲述了一群普通人陷入跨国诈骗陷阱后，凭借智慧与勇气展开自救的惊险故事。',
    tags: ['犯罪', '悬疑', '剧情'],
    updateTime: '2026-07-30',
  },
  {
    id: '6',
    title: '庆余年第二季',
    category: 'tv',
    rating: 9.1,
    year: 2025,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20fantasy%20drama%20poster%20with%20noble%20characters%20in%20elaborate%20traditional%20costumes%2C%20grand%20imperial%20palace%20setting%2C%20dramatic%20lighting%20with%20warm%20golden%20and%20deep%20crimson%20tones%2C%20artistic%20composition%20with%20ink%20wash%20painting%20elements&width=600&height=800&seq=featured-movie-06&orientation=portrait',
    description: '范闲在经历了第一季的生死考验后，继续在庆国朝堂与江湖之间周旋，揭开更多惊天秘密。',
    tags: ['古装', '权谋', '奇幻'],
    updateTime: '2026-07-20',
  },
];

export const latestUpdates = [
  {
    id: '7',
    title: '狂飙：最终章',
    category: 'tv',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20drama%20poster%20with%20intense%20confrontation%20between%20two%20characters%20in%20dim%20urban%20alley%2C%20rain-slicked%20streets%20reflecting%20neon%20lights%2C%20dark%20cinematic%20atmosphere%2C%20powerful%20emotional%20tension%2C%20Chinese%20contemporary%20setting&width=600&height=800&seq=latest-01&orientation=portrait',
    rating: 9.3,
    episode: '更新至38集',
  },
  {
    id: '8',
    title: '封神第二部',
    category: 'movie',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20film%20poster%20with%20legendary%20warriors%20and%20mystical%20creatures%2C%20grand%20ancient%20battlefield%20setting%2C%20dramatic%20celestial%20lighting%20with%20golden%20clouds%2C%20sweeping%20cinematic%20scale%2C%20ornate%20traditional%20Chinese%20aesthetics&width=600&height=800&seq=latest-02&orientation=portrait',
    rating: 8.9,
    episode: 'HD高清',
  },
  {
    id: '9',
    title: '乘风破浪的姐姐5',
    category: 'variety',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20poster%20with%20group%20of%20confident%20elegant%20female%20celebrities%20on%20glamorous%20stage%2C%20sparkling%20lights%20and%20dynamic%20energy%2C%20luxurious%20modern%20aesthetic%2C%20empowering%20atmosphere%20with%20warm%20spotlight%20glow&width=600&height=800&seq=latest-03&orientation=portrait',
    rating: 8.6,
    episode: '更新至第10期',
  },
  {
    id: '10',
    title: '哪吒之魔童闹海',
    category: 'anime',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20with%20rebellious%20young%20deity%20character%20surrounded%20by%20fire%20and%20water%20elements%2C%20dramatic%20cosmic%20battle%20scene%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20epic%20mythological%20atmosphere%2C%20stunning%20visual%20effects&width=600&height=800&seq=latest-04&orientation=portrait',
    rating: 9.4,
    episode: 'HD高清',
  },
  {
    id: '11',
    title: '他是谁',
    category: 'tv',
    imageUrl: 'https://readdy.ai/api/search-image?query=Suspenseful%20crime%20investigation%20drama%20poster%20with%20detective%20in%20rainy%20city%20night%2C%20moody%20blue%20and%20amber%20lighting%20contrast%2C%20mysterious%20atmosphere%2C%20urban%20Chinese%20setting%2C%20cinematic%20thriller%20aesthetic%20with%20dramatic%20shadows&width=600&height=800&seq=latest-05&orientation=portrait',
    rating: 8.4,
    episode: '更新至24集',
  },
  {
    id: '12',
    title: '满江红2',
    category: 'movie',
    imageUrl: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20suspense%20film%20poster%20set%20in%20ancient%20courtyard%20compound%20with%20narrow%20corridors%20and%20lanterns%2C%20dramatic%20interplay%20of%20light%20and%20shadow%2C%20rich%20warm%20color%20palette%2C%20atmospheric%20tension%2C%20traditional%20Song%20Dynasty%20architectural%20details&width=600&height=800&seq=latest-06&orientation=portrait',
    rating: 8.7,
    episode: 'HD高清',
  },
];

export const hotRanking = [
  { rank: 1, title: '狂飙：最终章', category: 'tv', hot: '982万', trend: 'up' },
  { rank: 2, title: '流浪地球3', category: 'movie', hot: '876万', trend: 'up' },
  { rank: 3, title: '哪吒之魔童闹海', category: 'anime', hot: '754万', trend: 'up' },
  { rank: 4, title: '乘风破浪的姐姐5', category: 'variety', hot: '689万', trend: 'up' },
  { rank: 5, title: '庆余年第二季', category: 'tv', hot: '621万', trend: 'down' },
  { rank: 6, title: '封神第二部', category: 'movie', hot: '587万', trend: 'up' },
  { rank: 7, title: '极限挑战第十季', category: 'variety', hot: '532万', trend: 'down' },
  { rank: 8, title: '孤注一掷2', category: 'movie', hot: '498万', trend: 'up' },
  { rank: 9, title: '长安十二时辰', category: 'tv', hot: '445万', trend: 'down' },
  { rank: 10, title: '深海', category: 'anime', hot: '398万', trend: 'up' },
];

export const faqs = [
  {
    question: '天美麻花星空影视是否需要注册才能观看？',
    answer: '天美麻花星空影视大部分内容支持免费观看，部分最新院线大片可能需要注册会员后观看。注册完全免费，只需手机号即可完成。',
  },
  {
    question: '支持哪些设备观看？画质如何？',
    answer: '天美麻花星空影视支持手机、平板、电脑等多种设备观看，画质提供标清、高清、超清多种选择，最高支持4K超高清画质，根据您的网络状况自动适配最佳清晰度。',
  },
  {
    question: '影片更新频率是怎样的？',
    answer: '我们每日更新大量最新影视内容。热门电视剧当日更新，院线电影下映后1-3个月内上线，综艺节目播出后24小时内更新，确保您不错过任何精彩内容。',
  },
  {
    question: '如何搜索我想看的影视内容？',
    answer: '您可以在首页顶部的搜索框中输入影片名称、演员或导演名称进行搜索。也可以通过分类导航浏览电影、电视剧、综艺、动漫等不同类型的内容。',
  },
  {
    question: '观看时需要缓冲吗？播放流畅吗？',
    answer: '天美麻花星空影视采用先进的CDN加速技术，全国多节点服务器部署，确保观影流畅不缓冲。建议在网络稳定的环境下观看，以获得最佳体验。',
  },
  {
    question: '遇到播放问题如何联系客服？',
    answer: '您可以通过网站底部的"联系我们"获取客服联系方式，或发送邮件至 contact@tianmeimahua.com，我们的客服团队会在24小时内为您解答。',
  },
];

export const aboutInfo = {
  intro: '天美麻花星空影视成立于2020年，是国内领先的在线影视内容平台。我们致力于为用户提供丰富、高清、流畅的影视观看体验，涵盖电影、电视剧、综艺、动漫等多种内容类型。经过多年的发展，天美麻花星空影视已经积累了海量的正版影视资源，服务超过5000万用户。',
  mission: '让每一个人都能轻松享受高品质的影视内容',
  vision: '成为中国最受用户喜爱的影视内容平台',
  values: [
    { title: '内容丰富', description: '海量影片库，涵盖各种类型，满足不同口味的观影需求' },
    { title: '高清画质', description: '最高支持4K超高清画质，带来沉浸式观影体验' },
    { title: '流畅稳定', description: '先进的播放技术，确保观影过程不卡顿、不缓冲' },
    { title: '用户至上', description: '以用户体验为核心，持续优化产品功能与服务' },
  ],
  milestones: [
    { year: '2020', event: '天美麻花星空影视正式上线，初始影片库超过5000部' },
    { year: '2021', event: '用户突破1000万，上线APP客户端' },
    { year: '2022', event: '影片库突破5万部，支持4K超高清画质' },
    { year: '2023', event: '用户突破3000万，荣获年度最佳影视平台奖' },
    { year: '2024', event: '全面升级推荐算法，上线AI智能推荐功能' },
    { year: '2025', event: '用户突破5000万，成为中国影视平台TOP3' },
  ],
  testimonials: [
    { name: '张先生', role: '资深影迷', content: '天美麻花星空影视的片库真的太全了！我想看的电影都能找到，画质也很棒，推荐给所有喜欢看电影的朋友。', rating: 5 },
    { name: '李女士', role: '追剧达人', content: '追剧神器！更新速度超快，再也不用到处找资源了。而且分类很清晰，找剧特别方便。', rating: 5 },
    { name: '王同学', role: '大学生', content: '免费的资源很多，宿舍四个人一起看电影太爽了。画面清晰不卡顿，体验感很好。', rating: 4 },
    { name: '赵女士', role: '全职妈妈', content: '孩子喜欢看动画片，这里动画资源特别多，而且好多是高清国语配音的，孩子看得开心我也放心。', rating: 5 },
  ],
};